import { render, staticRenderFns } from "./courseAdd.vue?vue&type=template&id=aad1178e&scoped=true"
import script from "./courseAdd.vue?vue&type=script&lang=js"
export * from "./courseAdd.vue?vue&type=script&lang=js"
import style0 from "./courseAdd.vue?vue&type=style&index=0&id=aad1178e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad1178e",
  null
  
)

export default component.exports